import item1 from './1.png';
import item2 from './2.png';
import item3 from './3.png';
import item4 from './4.png';
import item5 from './5.png';
import item6 from './6.png';
import item7 from './7.png';
import item8 from './8.png';
import item9 from './9.png';
import item10 from './10.png';
import item11 from './11.png';
import item12 from './12.png';
import item13 from './13.png';
import item14 from './14.png';
import item15 from './15.png';
import item16 from './16.png';
import item17 from './17.png';
import item18 from './18.png';
import item19 from './19.png';
import item20 from './20.png';
import item21 from './21.png';
import item22 from './22.png';
import item23 from './23.png';
import item24 from './24.png';
import item25 from './25.png';
import item26 from './26.png';
import item27 from './27.png';
import item28 from './28.png';
import item29 from './29.png';
import item30 from './30.png';
import item31 from './31.png';
import item32 from './32.png';
import item33 from './33.png';

/** Ключ — номер файла (1…33). */
export const DELIVERY_ITEM_IMAGES: Record<number, string> = {
  1: item1,
  2: item2,
  3: item3,
  4: item4,
  5: item5,
  6: item6,
  7: item7,
  8: item8,
  9: item9,
  10: item10,
  11: item11,
  12: item12,
  13: item13,
  14: item14,
  15: item15,
  16: item16,
  17: item17,
  18: item18,
  19: item19,
  20: item20,
  21: item21,
  22: item22,
  23: item23,
  24: item24,
  25: item25,
  26: item26,
  27: item27,
  28: item28,
  29: item29,
  30: item30,
  31: item31,
  32: item32,
  33: item33,
};
